import type { PioneerSlotOnboardingDisposition } from "./pioneerSlotDecision";

export type OwnerStartFlow =
  | "resume"
  | "dashboard"
  | "entitlement"
  | "pioneer"
  | "paid"
  | "recovery";

type OwnerStartDecisionInput = {
  ownerLoadFailed: boolean;
  hasBusinessToContinue: boolean;
  hasLockedExistingBusiness: boolean;
  hasAnyBusinessDocument: boolean;
  hasPaymentSession: boolean;
  hasEntitlementSlot: boolean;
  sessionLoadFailed: boolean;
  hasBusinessRecoveryBlock: boolean;
  pioneerSlotDisposition: PioneerSlotOnboardingDisposition;
};

/**
 * New acquisition is always paid. The Pioneer branch exists only so an
 * already-issued, still-valid legacy slot can be consumed.
 */
export function resolveOwnerStartFlow(
  input: OwnerStartDecisionInput
): OwnerStartFlow {
  if (input.ownerLoadFailed) return "recovery";
  if (input.hasLockedExistingBusiness) return "dashboard";
  if (input.hasBusinessToContinue) return "resume";
  if (input.pioneerSlotDisposition === "used") return "dashboard";

  if (input.hasPaymentSession) {
    return input.hasAnyBusinessDocument ||
      input.pioneerSlotDisposition === "usable" ||
      input.pioneerSlotDisposition === "recovery"
      ? "recovery"
      : "paid";
  }

  if (input.hasEntitlementSlot) return "entitlement";
  if (input.sessionLoadFailed) return "recovery";

  // Preserve already-issued Pioneer slots without offering new enrollment.
  if (input.pioneerSlotDisposition === "usable") return "pioneer";

  if (
    input.hasBusinessRecoveryBlock ||
    input.pioneerSlotDisposition === "recovery"
  ) {
    return "recovery";
  }

  return "paid";
}
